var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorCircleOutlineIcon = function SvgErrorCircleOutlineIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-662.000000, -120.000000)",
    fill: "#cacfd3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650,100 C652.76348,100 655.120989,100.978081 657.0726,102.934272 C659.02421,104.890464 660,107.245683 660,110 C660,112.754317 659.02421,115.109536 657.0726,117.065728 C655.120989,119.021919 652.76348,120 650,120 C647.23652,120 644.879011,119.021919 642.9274,117.065728 C640.97579,115.109536 640,112.754317 640,110 C640,107.245683 640.967984,104.898288 642.903981,102.957746 C644.871204,100.985906 647.23652,100 650,100 Z M650,102 C647.79471,102 645.910076,102.779719 644.346041,104.339181 C642.782006,105.898643 642,107.785564 642,110 C642,112.214436 642.782006,114.101357 644.346041,115.660819 C645.910076,117.220281 647.79471,118 650,118 C652.20529,118 654.089924,117.220281 655.653959,115.660819 C657.217994,114.101357 658,112.214436 658,110 C658,107.785564 657.217994,105.898643 655.653959,104.339181 C654.089924,102.779719 652.20529,102 650,102 Z M652.596491,106 L654,107.411765 L651.380117,110 L654,112.588235 L652.596491,114 L649.976608,111.411765 L647.403509,114 L646,112.588235 L648.573099,110 L646,107.411765 L647.403509,106 L649.976608,108.588235 L652.596491,106 Z",
    id: "ic_error_circle_outline"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorCircleOutlineIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-circle-outline-icon.c8ec312b.svg";
export { ForwardRef as ReactComponent };